<template>
	<div class="animate-pulse rounded-xl" />
</template>
